import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SortableList } from '../../components/form/SortedBy'
import CrudAbout from './CrudAbout'
import { fetchShowcaseGetAllByAbout } from '../../redux/slices/showcaseGetAllByAboutSlice'
import { fetchShowcaseSort } from '../../redux/slices/showcaseSortSlice'
import { fetchShowcaseDelete } from '../../redux/slices/showcaseDeleteSlice'

const AboutPage = () => {
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const abouts = useSelector((state) => state.showcaseGetAllByAbout.data)
    const status = useSelector((state) => state.showcaseGetAllByAbout.status)
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchShowcaseGetAllByAbout())
        setChanged(false)
    }

    const handleSorted = (newList) => {
        abouts.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchShowcaseSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, changed])

    const deleteData = async (id) => {
        await dispatch(fetchShowcaseDelete({ id: id }))
        getData()
    }

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={t("about_management")}
                description={t("about_management_desc")}
                buttonText={t("add_showcase")}
            />

            {status === "succeeded" ?
                <SortableList
                    setModal={setModal}
                    list={abouts ? [...abouts].sort((a, b) => a.sort - b.sort) : []}
                    onChange={handleSorted}
                    setChanged={setChanged}
                    deleteData={deleteData}
                    contentTitle={t("design")}
                    contentUrl="/about-design"
                    setSelectedItem={setSelectedItem}
                /> : null
            }

            <CrudAbout
                showMenu={modal}
                setShowMenu={setModal}
                selectedItem={selectedItem}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                t={t}
            />
        </CMS>
    )
}

export default AboutPage
